fragment BulkEditFragment on BulkEdit {
    id
    user {
        id
        name
    }
    status
    createdTime
    startedTime
    completedTime
    entityType
}
